import { SxProps, Theme } from '@mui/material'

export const surfaceCardSx: SxProps<Theme> = {
  backgroundColor: 'rgba(255, 255, 255, 0.78)',
  border: '1px solid #E4E8F2',
  borderRadius: 4,
  boxShadow: '0 1px 2px rgba(32, 56, 100, 0.04)',
}
